import { QuestionType } from '@commutifi/models/Question'
import { ReferenceKey } from '@commutifi/constants/ReferenceKeys'

export const baseQuestion = {
  enabled: true,
  optional: false,
  conditionalMode: null,
  conditionalCategory: null,
  conditionalValue: null,
  conditionalQuestionId: null,
  configuration: {},
  category: null,
  referenceKey: null
}

export enum COMPONENT_TYPES {
  Component = 'component',
  Module = 'module'
}

export const deletableCoreQuestionTypeRefKeyMap = new Map<QuestionType, ReferenceKey[]>([
  [QuestionType.vehicleSelector, [ReferenceKey.commuteProfileVehicleId]],
  [
    QuestionType.costSelector,
    [
      ReferenceKey.commuteCostParking,
      ReferenceKey.commuteCostCarpoolDriver,
      ReferenceKey.commuteCostCarpoolPassenger,
      ReferenceKey.commuteCostVanpool,
      ReferenceKey.commuteCostShuttle,
      ReferenceKey.commuteCostPublicTransit,
      ReferenceKey.commuteCostBikesharing,
      ReferenceKey.commuteCostSharedScooter
    ]
  ],
  [
    QuestionType.numberInput,
    [ReferenceKey.commuteProfilePeopleCountCarpooling, ReferenceKey.commuteProfilePeopleCountVanpool]
  ]
])

export const coreQuestionTypeRefKeyMap = new Map<QuestionType, ReferenceKey[]>([
  ...deletableCoreQuestionTypeRefKeyMap.entries(),
  [QuestionType.addressAutocomplete, [ReferenceKey.accountAddress]],
  [QuestionType.enterpriseSelector, [ReferenceKey.accountEnterpriseId]],
  [QuestionType.officeSelector, [ReferenceKey.accountOfficeId]],
  [QuestionType.daySelector, [ReferenceKey.commuteProfileFrequency, ReferenceKey.commuteProfileRemoteFrequency]],
  [QuestionType.timeSelector, [ReferenceKey.commuteProfileArrive, ReferenceKey.commuteProfileLeave]],
  [QuestionType.commuteRouter, [ReferenceKey.commuteProfileRoute]]
])
